<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import ErrorMessage from "../../components/error-message";
import { ModelSelect } from 'vue-search-select';
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
      ModelSelect
  },
  data() {
    return {
      errorMessage: "",
      title: "Pin Update",
      items: [
        {
          text: "Admin",
          href: "/",
        },
        {
          text: "Pin Update",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
      admins: [],
        visible:false,
        message:"",
        lineError:true,
      pinid: "",
      form: {
        user_id: "",
        pin: ""
      },
      submitform: false,
      submitted: false,
      state: false
    };
  },
  validations: {
    form: {
      user_id: {
        required,
      },
      pin: {
        required,
      },
    },
  },
  created() {
    this.pinid = this.$route.params.id;
  },
  mounted() {
    this.getAdminList();
    this.getPinDetail();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
    async getPinDetail() {
      try {
          axios
          .get("/api/admin/pin/"+ this.pinid, {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              var data = response.data.data;
              this.form.pin = data.pin;
              this.form.user_id = data.user_id;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getAdminList() {
      try {
        axios
          .get("/api/admin/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
                var temp=response.data.data;
                var i;
                for (i=0;i<temp.length;i++){
                    if(temp[i].account_type == 'admin'){
                        temp[i].value = temp[i].id;
                        temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                    }

                }
                this.admins = temp;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .put("/api/admin/pin", {
          id: this.pinid,
          pin: this.form.pin,
          user_id: this.form.user_id,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.pinUpdateForm.reset();
              this.$swal("Good job!", "Admin Pin Updated", "success");
            this.$router.push({ name: "pin_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.lineError=false;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
    passwordEyeToggle() {
      var x = document.getElementById("pin");
      var y = document.getElementById("eye-1");
      var z = document.getElementById("eye-2");

      if(x.type === "password"){
        x.type = "text";
        y.style.display = "block";
        z.style.display = "none";
      }
      else{
        x.type = "password";
        y.style.display = "none";
        z.style.display = "block";
      }
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors && lineError" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="pinUpdateForm" @submit.prevent="formSubmit">
              <div class="row">
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Select User</label>
                          <model-select :options="admins"
                                        v-model="form.user_id"
                                        placeholder="Select Admin">
                          </model-select>
                      </div>
                  </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="pin">Pin</label>
                    <input
                      id="pin"
                      v-model="form.pin"
                      name="pin"
                      type="password"
                      class="form-control"
                      placeholder="Type role name"
                      value="form.pin"
                      :class="{ 'is-invalid': submitted && $v.form.pin.$error }"
                    />
                    <span class="eye" >
                      <i class="fa fa-eye" aria-hidden="true" @click="passwordEyeToggle()" id="eye-1"> </i>
                      <i class="fa fa-eye-slash" aria-hidden="true" @click="passwordEyeToggle()" id="eye-2"> </i>
                    </span>
                    <div
                      v-if="submitted && $v.form.pin.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.pin.required">This value is required.</span>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">Update</button>
                <div class="col-md-12 height-300px">

                </div>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

  </Layout>
</template>

<style>
  .eye{
    display: flex;
    position: absolute;
    right: 20px;
    top: 40px;
  }
  #eye-1{
    display: none;
  }
</style>
